import Http from '../utils/axios'
const upload = '/api-zendai/zuul/user'
const user = `/api-zendai/user`
export default {
    /*
    ***  上传附件
    */
    uploadUrl() {
        return `${upload}/v1/e/upload/attach`;
    },
    findAllConfig(params){
        return Http.get(`${user}/v1/e/config/api/findAllConfig`,params,true)
    },
    save(params){
        return Http.post(`${user}/v1/e/config/api/saveOrUpdateBatch`,params,true)
    }
}
